import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { renderUserAvatar } from "@/lib/avatar";

export default function MentionsView() {
  const [msgs, setMsgs] = useState([]);
  useEffect(() => { api.get("/mentions").then((r) => setMsgs(r.data)); }, []);
  return (
    <div className="flex-1 flex flex-col overflow-hidden bg-white">
      <div className="h-14 border-b flex items-center px-6 shrink-0"><h1 className="text-lg font-semibold">Mentions</h1></div>
      <div className="flex-1 overflow-auto p-6 max-w-2xl space-y-2 scroll-thin">
        {msgs.length === 0 && <div className="text-sm text-zinc-400">No mentions yet.</div>}
        {msgs.map((m) => (
          <div key={m.id} className="p-3 border rounded-lg">
            <div className="flex items-center gap-2 mb-1"><img src={renderUserAvatar(m.user)} className="w-6 h-6 rounded-full object-cover" alt=""/><span className="text-sm font-medium">{m.user?.name}</span><span className="text-xs text-zinc-400">{new Date(m.created_at).toLocaleString()}</span></div>
            <div className="text-sm">{m.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
